// extracted by mini-css-extract-plugin
module.exports = {"container__section":"page_container__section__okD6w"};